import { useEffect, useRef, useState } from "react";
import CommentsTickets from "./CommentsTicket";
import axios from "../axios";
import { useSelector } from "react-redux";
import './TicketUi.css'
const ExpandTicket = ({ setExpanded, setTicketOpned, data, setRefetch, refetch }) => {
  const [message, setMessage] = useState(null);
  const [refetchReply, setRefetchReply] = useState(false);
  const bottomRef = useRef(null);

  const [reply, setReply] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [dataFetching, setDataFetching] = useState(false)
  const userId = useSelector((state) => state?.user?.currentUser?.id);

  const scrollToBottom = () => {
    console.log("scroll ", bottomRef.current)
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  function formatTime(timeString) {
    const time = new Date(timeString);
    let hours = time.getHours();
    const minutes = time.getMinutes();
    const period = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    const paddedMinutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${paddedMinutes} ${period}`;
  }

  const fetchReply = async () => {
    try {
      setDataFetching(true)
      let response = await axios.get(`/ticket/reply/get/${data?.id}`);
      if (response) {
        setReply(response.data.data);
        setDataFetching(false)
        setTimeout(() => { scrollToBottom(); }, 200)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    fetchReply()
  }, [refetchReply, data]);
  const handleReplyCreation = async () => {
    try {
      setIsLoading(true)
      let response = await axios.post(`/ticket/${data?.id}/reply/create`, {
        "user_id": userId,
        "reply": message,
        "attachments": [],
        "attachments_sizeKb": []
      });
      setMessage('');
      console.log("response : ", response)
      if (response) {
        setReply((prev) => [...prev, response.data.data]);
        setTimeout(() => { scrollToBottom(); }, 200)
        await fetchReply()
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false)
  }
  return (
    <>
      <div className="flex gap-2 items-center justify-between">
        <div className="flex gap-2 items-center">
          <img
            style={{ cursor: "pointer" }}
            onClick={() => { setExpanded(false); setTicketOpned(false) }}
            src="/HwImg/backArrow.png"
            alt=""
          />
          <div className="">Tickets</div>
        </div>
        <div>
          <button
            style={{ width: "80%", marginRight: "20px" }}
            className="mt-2 btn btn-success"
            onClick={() => { setReply([]); fetchReply() }}
          >
            Refresh
          </button>
        </div>
      </div>
      <div className="subjectWise_query_file_path">
        <div className="query_list_box_ticket mt-3">
          <div className="d-flex justify-content-between">
            <div className="w-full flex justify-between items-center">
              <p className="mt-1 ml-3 comments-text" style={{ width: "85%", fontSize: "18px", fontWeight: 600, color: "black" }}>{data?.ticket}</p>
              <div className="flex items-center">
                <p className="mt-1 ml-3 flex gap-2" style={{ fontSize: "13px", fontWeight: 400 }}><div>{reply?.length}</div> <span>Comments</span></p>
                <p className="mt-1 ml-3 w-24" style={{ fontSize: "13px", fontWeight: 400 }}>{formatTime(data?.updated_at)}</p>
              </div>
            </div>

          </div>
          <div className="mt-1 ml-3 comments-text orange-scrollBar" style={{ width: "97%", height: "70px", overflowY: "scroll" }}>{data?.description}</div>
          <span className="count_reply_header">{reply?.length} Comments</span>
          <div id="inner-scrollable-reply" className="reply_box_ticket orange-scrollBar">
            {
              dataFetching ?
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <img
                    style={{ width: "100px" }}
                    src="/gif/LoaderDot.gif"
                    alt=""
                  />
                </div> :
                reply.map((data) => (
                  <CommentsTickets key={data.id} data={data} userId={userId} />
                ))
            }

            <div ref={bottomRef} />

          </div>
          <div className="mt-4 message_input_group">
            <div className="d-flex justify-content-between">
              <input
                type="text"
                className="col-sm-11 col-5 p-0 px-2 py-2 form_control w-100"
                maxLength={250}
                placeholder="Type message "
                value={message}
                onChange={(e) => { setMessage(e.target.value) }}
              />
              {
                <button disabled={!message}>
                  <img
                    src={isLoading ? "/gif/Loader.gif" : "/images/send button.svg"}
                    className="mr-3"
                    alt=""
                    style={{ cursor: "pointer", width: isLoading && "28px", height: isLoading && "28px" }}
                    onClick={() => {
                      if (message || !isLoading) {
                        handleReplyCreation()
                      }
                    }}
                  />
                </button>
              }

            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default ExpandTicket;
